import React from "react";
import { Ribbon } from "./Ribbon";
import { PLAYER_DESTINATIONS } from "./destinations";

/**
 * DestinationRow — the player's ribbon. Issue #760 built it as D92's
 * three-chip row (Record, Plan, Grounds); D214.1 added Training & guides as
 * the fourth destination and D216/D221 O1 made every menu one scrolling
 * ribbon, so issue #1119 reduced this to a thin wrapper over `Ribbon` with
 * `PLAYER_DESTINATIONS`. The nine player callers compile unchanged, and
 * `nav-destinations` stays the band's testid (the nav guard selects it).
 *
 * D92's "the coach gets no row" is superseded for the coach by #1121 (the
 * coach's own ribbon); every caller of this component is still player-only.
 *
 * `current` selects the destination that reads as "you are here" (the white
 * pill, not a link by default). `onCurrentClick` is the opt-in that makes
 * the current item alone a button (Plan's `?new=1` way off, #763 F1).
 */
export function DestinationRow({ current, onCurrentClick, className = "", "data-testid": testId = "nav-destinations", ...rest }) {
  return (
    <Ribbon
      items={PLAYER_DESTINATIONS}
      currentKey={current}
      onCurrentClick={onCurrentClick}
      className={className}
      data-testid={testId}
      {...rest}
    />
  );
}

export default DestinationRow;
